import { passwordStrength } from 'check-password-strength';

import { TranslationRepository } from '~repositories/TranslationRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

import { IPasswordStrengthItem } from './Config';

enum PasswordStrength {
    MEDIUM = 'Medium',
    STRONG = 'Strong'
}

interface PasswordStrengthLevel {
    passwordValue: string;
    totalLevel: number;
    levelLabels: IPasswordStrengthItem[];
}

export class Password {
    private translationRepository = diContainer.get(
        serviceNames.translationRepository
    ) as TranslationRepository;

    public getPasswordScore = (password = ''): number => {
        let score = 0;

        const { value } = passwordStrength(password);

        if (value === PasswordStrength.MEDIUM) {
            score = 3;
        } else if (value === PasswordStrength.STRONG) {
            score = 4;
        }

        return score;
    };

    public getPasswordStrengthData = (passwordData: PasswordStrengthLevel) => {
        const { passwordValue, totalLevel, levelLabels } = passwordData;

        const score = this.getPasswordScore(passwordValue);
        let level = Math.round((score / 4) * totalLevel);
        level = level === 0 ? 1 : level; // follow the behavior of CL ES
        const matchedLevelItem = levelLabels[level];
        const levelLabel = this.translationRepository.translations[matchedLevelItem.labelKey];

        return {
            level,
            levelName: matchedLevelItem.name,
            levelLabel
        };
    };
}
